module.exports = __webpack_public_path__ + "static/media/gpc-original.afcef111.png";